import React from "react";

import { ResponsiveSwarmPlot, SwarmPlotAnnotations } from "@nivo/swarmplot";
import { useState } from "react";
import { PatternLines } from "@nivo/core";
import _ from "lodash";
import * as d3 from "d3";

// import { Annotation, useAnnotations } from '@nivo/annotations'

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
// https://blog.logrocket.com/react-area-chart-comparison/ //
// without div styling, chart doesnt show up

const CustomNodes = (d) => {
  // you can use d.node here
  //group related code here

  return (
    <g
      id={d.node.data.id}
      transform={`translate(${d.x},${d.y})`}
      onMouseOver={(data, event) => {
        console.log("customMode" + d.node.id);
        d.onChildClick(`${d.node.data.id}`);
        // alert(`${d.node.id} ${d.node.group}`);
      }}
    >
      {/* <circle r={d.node.size / 2} stroke="rgb(216, 218, 235)" strokeWidth={12} /> */}
      <circle
        r={d.size / 2}
        fill={d.node.data.fill_color}
        stroke={d.node.data.stroke_color}
        strokeWidth={2}
      />

      {d.size > 5 && (
        <text
          fill={d.node.data.font_color}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: 9
            // fontWeight: "bold"
          }}
        >
          {d.node.data.id}
        </text>
      )}
    </g>
  );
};

const NivoSwarmPlot = ({
  data,
  onChildClick,
  xAxisVariable,
  groupVariable,
  currentIndex,
  configData,
  sizeVariable,
  showAll,
  xAllMin,
  xAllMax
}) => {
  // const [currentIndex, setCurrentIndex] = useState(13);
  const groups_in = _.values([
    ...new Set(data.map((item) => item[groupVariable]))
  ]);
  const size_extent = d3.extent(_.map(data, sizeVariable));
  const value_min = xAllMin;
  const value_max = xAllMax;
  let size_array;
  if (showAll === 1) {
    size_array = [20, 40];
  } else {
    size_array = [30, 55];
  }
  // const size_array === {showAll?} [25, 45]: [30:50]
  return (
    //height attribute is must
    <div
      // left={styles.left}
      style={{ maxWidth: "100%", margin: "0 auto", height: "1000px" }}
    >
      <ResponsiveSwarmPlot
        data={data}
        groups={groups_in}
        value={xAxisVariable}
        valueFormat="%"
        valueScale={{
          type: "linear",
          min: value_min,
          max: value_max,
          reverse: false
        }}
        size={{ key: sizeVariable, values: size_extent, sizes: size_array }}
        forcesStrength={4}
        simulationIterations={100}
        spacing={7}
        layout="horizontal"
        borderColor={{
          from: "color",
          modifiers: [
            ["darker", 0.6],
            ["opacity", 0.5]
          ]
        }}
        enableGridX={true}
        margin={{ top: 100, right: 50, bottom: 80, left: 150 }}
        axisTop={{
          orient: "top",
          tickSize: 10,
          tickPadding: 50,
          tickRotation: 0,
          legend:
            "X-Axis is : " +
            [xAxisVariable] +
            ".   Size is : " +
            [sizeVariable],
          legendPosition: "end",
          legendOffset: -30
        }}
        tooltip={(slice) => {
          return (
            <div>
              <h2>{slice.node.id}</h2>
              <h2>{slice.node.group}</h2>
            </div>
          );
        }}
        // axisBottom={{
        //   orient: "bottom",
        //   tickSize: 10,
        //   tickPadding: 5,
        //   tickRotation: 0,
        //   legend:
        //     "X-Axis is : " +
        //     [xAxisVariable] +
        //     ".   Size is : " +
        //     [sizeVariable],
        //   legendPosition: "middle",
        //   legendOffset: 36
        // }}
        motionStiffness={50}
        motionDamping={10}
        renderNode={(props) => (
          <CustomNodes {...props} onChildClick={onChildClick} />
        )}
        layers={[
          "grid",
          "axes",
          backgroundLayer,
          (props) => <SearchHighlight {...props} currentIndex={currentIndex} />, // this is enable basedon search
          "nodes"
        ]}
        theme={theme}
      />
    </div>
  );
};

const theme = {
  background: "E8E8E8",
  axis: {
    ticks: {
      line: {
        stroke: "rgb(84, 39, 136)"
      },
      text: {
        fill: "gray",
        // fontWeight: 800,
        fontSize: 14
      }
    },
    legend: {
      text: {
        fill: "gray",
        fontSize: 20
      }
    }
  },
  grid: {
    line: {
      stroke: "rgb(128, 115, 172)",
      strokeDasharray: "2 4",
      strokeWidth: 1
    }
  }
};

const SearchHighlight = ({ nodes, margin, innerWidth, currentIndex }) => {
  const node = nodes[currentIndex];
  let radius;
  if (typeof node !== "undefined") {
    radius = node.size;
  }
  if (typeof node === "undefined") {
    return <> </>;
  } else {
    return (
      <g style={{ pointerEvents: "none" }}>
        <circle
          cx={node.x}
          cy={node.y}
          r={radius}
          fill="red"
          strokeWidth={4}
          stroke="red"
        />
      </g>
    );
  }
};

// Note hre we will be usig fragments
const backgroundLayer = ({ xScale, innerHeight }) => {
  const circle = (
    <circle cx={20} cy={50} r={100} fill="red" stroke={theme.accent} />
  );

  return (
    <>
      <defs>
        <PatternLines
          id="linesPattern"
          spacing={10}
          rotation={-45}
          background="rgb(199, 234, 229)"
          color="rgb(128, 205, 193)"
          lineWidth={1}
          // opacity="0.3"
        />
      </defs>
      <rect
        x={xScale(0)}
        y={0}
        width={xScale(5000) - xScale(0)}
        height={innerHeight}
        fill="url(#linesPattern)"
        opacity="0.25"
      />

      <text
        x={xScale(225)}
        y={26}
        textAnchor="middle"
        fill="rgb(0, 60, 48)"
        style={{
          fontSize: 16,
          fontWeight: 800
        }}
      >
        Outliers
      </text>
    </>
  );
};

export default NivoSwarmPlot;
